$(function() {
    /**
     * These variables are from product-bundle-info section
     * - mainProduct
     * - product1
     * - product2
     * - pillow1
     * - pillow2
     * - pillow3
     */

    const productData = {
        size: '',
        color: '',
        mattressSize: '',
        pillow1: '',
        pillow2: ''
    };

    const productVariantIds = {
        productPillow2: '',
        productPillow1: '',
        product1: '',
        product2: '',
        product3: '',
        mattress: ''
    };

    const productPrices = {
        mattress: {compare_at_price: 0, price: 0},
        product1: {compare_at_price: 0, price: 0},
        product2: {compare_at_price: 0, price: 0},
        product3: {compare_at_price: 0, price: 0},
        productPillow1: {compare_at_price: 0, price: 0},
        productPillow2: {compare_at_price: 0, price: 0}
    }

    const mainProductPrice = {
        compare_at_price: 0,
        price: 0
    }

    function getPillowProduct(num) {
        let pillowProduct = '';
        if(num == 1) {
            pillowProduct = pillow1;
        } else if(num == 2) {
            pillowProduct = pillow2;
        } else if(num == 3) {
            pillowProduct = pillow3;
        }

        return pillowProduct;
    }

    function getProduct12Details(varArray) {
        let details = {
            varId: '',
            price: 0,
            compareAtPrice: 0,
        }
        
        if(varArray.length) {
            details.varId = varArray[0].id;
            details.price = varArray[0].price;
            details.compareAtPrice = varArray[0].compare_at_price;
        }

        return details;
    }

    function getMattressDetails(varArray) {
        let details = {
            varId: '',
            price: 0,
            compareAtPrice: 0,
        }
        
        if(varArray.length) {
            details.varId = varArray[0].id;
            details.price = varArray[0].price;
            details.compareAtPrice = varArray[0].compare_at_price;
        }

        return details;
    }

    function getProductPillowDetails(pillowNum) {
        let details = {
            varId: '',
            price: 0,
            compareAtPrice: 0,
        }

        if(productData[pillowNum] != '') {
            details.varId = productData[pillowNum].variants[0].id;
            details.price = productData[pillowNum].variants[0].price;
            details.compareAtPrice = productData[pillowNum].variants[0].compare_at_price;
        }

        return details;
    }

    function setProductDetails(productType, varId, price, compareAtPrice) {
        productVariantIds[productType] = varId;
        productPrices[productType].price = price;
        productPrices[productType].compare_at_price = compareAtPrice;
    }

    function setProduct() {
        /* Set bedroom bundle size */
        const currMattressSize = $('.mattress-size:not(.hide-mobile)').find('select').val();

        if($('.mattress-size:not(.hide-mobile)').length) {
            productData.mattressSize = $('.mattress-size:not(.hide-mobile)').find('select').val();
        }
        if($('.product-variant-colors .each.active').length) {
            const color = $('.product-variant-colors .each.active').data('value');
            productData.color = color;
        }
        if($('.variant-pillow.active[data-pillow-num="1"]').length) {
            productData.pillow1 = getPillowProduct($('.variant-pillow.active[data-pillow-num="1"]').data('product-num'));
        }
        if($('.variant-pillow.active[data-pillow-num="2"]').length) {
            productData.pillow2 = getPillowProduct($('.variant-pillow.active[data-pillow-num="2"]').data('product-num'));
        }

        /* Getting mattress variant */
        if($('.product-variant-mattress .each-pro.active').attr('data-index') == '1') {
            mattress = mattress1;
        } else if($('.product-variant-mattress .each-pro.active').attr('data-index') == '2') {
            mattress = mattress2;
        } else if($('.product-variant-mattress .each-pro.active').attr('data-index') == '3') {
            mattress = mattress3;
        } else {
            mattress = mattress4;
        }

        if(mattress) {
            const mattressSizeIndex = `option${mattress.options.findIndex(opt => opt == 'Size') + 1}`;
            const mattressVar = mattress.variants.filter(variant => {
                return variant[mattressSizeIndex] == productData.mattressSize;
            });

            productMattressDetails = getMattressDetails(mattressVar);
            setProductDetails('mattress', productMattressDetails.varId, productMattressDetails.price, productMattressDetails.compareAtPrice);

            if(mattressVar.length) {
                if( !mattressVar[0].available ) {
                    alert(`${mattressVar[0].name} is sold out!`);
                }
            }
            
        }

        if(productVariantIds.mattress != '') {
            $('.product-variant-size .each-size.active').removeClass('active');
            if(currMattressSize.includes("Single")) {
                if(currMattressSize.includes("Small Single")) {
                    $('.product-variant-size .each-size[data-value*="Small Single"]').addClass('active');
                } 
                else if(currMattressSize.includes("Large Single")) {
                    $('.product-variant-size .each-size[data-value*="Large Single"]').addClass('active');
                }
                else if(currMattressSize.includes("Single Long")) {
                    $('.product-variant-size .each-size[data-value*="Single Long"]').addClass('active');
                }
                else {
                    $('.product-variant-size .each-size[data-value*="Single"]').addClass('active');
                    $('.product-variant-size .each-size[data-value*="Small Single"]').removeClass('active');
                    $('.product-variant-size .each-size[data-value*="Large Single"]').removeClass('active');
                    $('.product-variant-size .each-size[data-value*="Single Long"]').removeClass('active');
                }
            } else if (currMattressSize.includes("Double")) {
                if(currMattressSize.includes("Double Long")) {
                    $('.product-variant-size .each-size[data-value*="Double Long"]').addClass('active');
                }
                else {
                    $('.product-variant-size .each-size[data-value*="Double"]').addClass('active');
                    $('.product-variant-size .each-size[data-value*="Double Long"]').removeClass('active');
                }
            } else if (currMattressSize.includes("Full")) {
                $('.product-variant-size .each-size[data-value*="Full Long"]').addClass('active');
            } else if (currMattressSize.includes("Queen")) {
                if(currMattressSize.includes("Queen Long")) {
                    $('.product-variant-size .each-size[data-value*="Queen Long"]').addClass('active');
                }
                else {
                    $('.product-variant-size .each-size[data-value*="Queen"]').addClass('active');
                    $('.product-variant-size .each-size[data-value*="Queen Long"]').removeClass('active');
                }
            } else if (currMattressSize.includes("King")) {
                $('.product-variant-size .each-size[data-value*="King"]').addClass('active');
            }
        }

        if($('.product-variant-size .each-size.active').length) {
            const size = $('.product-variant-size .each-size.active').attr('data-value');
            productData.size = size;
        }
        /* Getting product 1 variant */
        const product1SizeOptionIndex = `option${product1.options.findIndex(opt => opt == 'Size') + 1}`;
        const product1ColorOptionIndex = `option${product1.options.findIndex(opt => opt == 'Color') + 1}`;

        let pro1SizeName = productData.size.split(' (')[0];
        switch (pro1SizeName) {
            case 'Small Single':
                pro1SizeName = 'Single'
                break;
            case 'Single':
                pro1SizeName = 'Single'
                break;
            case 'Single Long':
                pro1SizeName = 'Single'
                break;
            case 'Large Single':
                pro1SizeName = 'Single'
                break;
            case 'Double':
                pro1SizeName = 'Double'
                break;
            case 'Double Long':
                pro1SizeName = 'Double'
                break;
            case 'Full Long':
                pro1SizeName = 'Full'
                break;
            case 'Queen Long':
                pro1SizeName = 'Queen'
                break;
        }
        const product1Var = product1.variants.filter(variant => {
            const varSize = variant[product1SizeOptionIndex].split(' ')[0];
            return varSize == pro1SizeName && variant[product1ColorOptionIndex] == productData.color;
        });
        product1Details = getProduct12Details(product1Var);
        setProductDetails('product1', product1Details.varId, product1Details.price, product1Details.compareAtPrice);
        /* Getting product 1 variant */

        console.log("pro 1", product1Var);


        if(productData.size != '') {
            const sizeName = productData.size.split(' (')[0];

            /* Getting product 2 variant id */
            const product2Var = product2.variants.filter(variant => {
                const vSizeName = variant.option1.split(' (')[0];
                return sizeName == vSizeName;
            });
            product2Details = getProduct12Details(product2Var);
            setProductDetails('product2', product2Details.varId, product2Details.price, product2Details.compareAtPrice);

            console.log("pro 2", product2Var);
            /* Getting product 2 variant id */

            // Getting duvet
            /*
            let duvetSize = sizeName
            switch (duvetSize) {
                case 'Small Single':
                    duvetSize = 'Single'
                    break;
                case 'Single':
                    duvetSize = 'Single'
                    break;
                case 'Single Long':
                    duvetSize = 'Single'
                    break;
                case 'Large Single':
                    duvetSize = 'Single'
                    break;
                case 'Double':
                    duvetSize = 'Double / Full'
                    break;
                case 'Double Long':
                    duvetSize = 'Double / Full'
                    break;
                case 'Full Long':
                    duvetSize = 'Double / Full'
                    break;
                case 'Queen':
                    duvetSize = 'Queen / King'
                    break;
                case 'Queen Long':
                    duvetSize = 'Queen / King'
                    break;
                case 'King':
                    duvetSize = 'Queen / King'
                    break;
            }
            const duvetVar = duvet.variants.filter(variant => {
                const vSizeName = variant.option1;
                return duvetSize == vSizeName;
            });
            duvetDetails = getProduct12Details(duvetVar);
            setProductDetails('product3', duvetDetails.varId, duvetDetails.price, duvetDetails.compareAtPrice);

            console.log("pro 3", duvetVar);
            */
            // end getting duvet
        }

        /* Getting product pillow 1 variant id */
        productPillow1Details = getProductPillowDetails('pillow1')
        setProductDetails('productPillow1', productPillow1Details.varId, productPillow1Details.price, productPillow1Details.compareAtPrice);
        /* Getting product pillow 1 variant id */

        /* Getting product pillow 2 variant id */
        productPillow2Details = getProductPillowDetails('pillow2')
        setProductDetails('productPillow2', productPillow2Details.varId, productPillow2Details.price, productPillow2Details.compareAtPrice);
        /* Getting product pillow 2 variant id */

        /* Calculate the price */
        let originalPrice = 0;
        let reducedPrice = 0;
        let compareAtPrice = 0;
        Object.keys(productPrices).forEach(function(key) {
            originalPrice += productPrices[key].price;
            compareAtPrice += productPrices[key].compare_at_price;
        });
        reducedPrice = originalPrice > 0 ? originalPrice * bundleDiscountSettings : originalPrice;

        // const savePrice = compareAtPrice > 0 ? compareAtPrice - reducedPrice : compareAtPrice;
        const savePrice = originalPrice - reducedPrice;
        $('.product-info-price .product-price-strike .money').html(Shopify.formatMoney(originalPrice, 'HK${{amount}}'));
        $('.product-info-price .product-price .money').html(Shopify.formatMoney(reducedPrice, 'HK${{amount}}'));
        $('.product-info-price .product-price-savings .money').html(Shopify.formatMoney(savePrice, 'HK${{amount}}'));

        if(originalPrice > 0) {
            $('.product-info-price .product-price-strike').show();
            $('.product-info-price .product-price-savings').show();

            const priceBtnWidth = $('.price-and-button').outerWidth();
            const priceWidth = $('.price-and-button .product-info-price').outerWidth();
            const buyBtnWidth = $('.price-and-button .product-submit-btn').outerWidth();

            if(priceWidth + buyBtnWidth > priceBtnWidth) {
                $('.price-and-button .product-info-price').css({'margin-bottom': '20px'});
            } else {
                $('.price-and-button .product-info-price').css({'margin-bottom': ''});
            }
        } else {
            $('.product-info-price .product-price-strike').hide();
            $('.product-info-price .product-price-savings').hide();
        }
        /* End calculate the price */

        mainProductPrice.compare_at_price = originalPrice;
        mainProductPrice.price = reducedPrice;

        if(productData.size != '' && productData.color != '' && productData.pillow1 != '' && productData.pillow2 != '') {
            $('.price-and-button').css({display: ''});
        } else {
            $('.price-and-button').css({display: 'none'});
        }
    }

    setProduct();

    $('.product-variant-size .each-size').on('click', function(e) {
        $('.product-variant-size .each-size').removeClass('active');
        $(this).addClass('active');
        setProduct();
    });

    $('.product-variant-colors .each').on('click', function() {
        $('.product-variant-colors .each').removeClass('active');
        $(this).addClass('active');
        setProduct();

        const colorHandle = $(this).data('handle')
        updateMainImage(`${product1.id}-${colorHandle}`);
        updateMobileImages(`${product1.id}-${colorHandle}`);
    });

    $('.product-variant-pillow .variant-pillow').on('click', function() {
        $(this).parent().find('.variant-pillow').removeClass('active');
        $(this).addClass('active');
        setProduct();
    });

    $('.product-form').on('submit', function(e) {
        e.preventDefault();

        let errorMsg = '';
        if(productVariantIds.mattress == '') {
            errorMsg += ` Mattress,`
        }
        if(productData.color == '') {
            errorMsg += ` Color,`
        }
        if(productData.pillow1 == '') {
            errorMsg += ` 1st Pillow,`
        }
        if(productData.pillow2 == '') {
            errorMsg += ` 2nd Pillow`
        }

        if(errorMsg != '') {
            alert(`Please select${errorMsg.replace(/,\s*$/, '')}!`);
            return;
        }

        $('#product-buy').html('Adding to cart...').attr('disabled', true);

        nonce = new Date().getTime() + Math.floor(Math.random() * 100000);
        var attributes = {};
        Shopify.queue = [];
        Object.keys(productVariantIds).forEach(function(key) {
            var prop = {};
            prop["_groupmovein"] = nonce;
            prop["Part of"] = globalProductTitle;

            Shopify.queue.push({
                variantId: productVariantIds[key],
                quantity: 1,
                properties: prop
            });
        });

        let main_compare_at_price = 0;
        if(mainProduct.compare_at_price != "null" && mainProduct.compare_at_price != null) {
            main_compare_at_price = mainProduct.compare_at_price;
        }

        attributes["groupmovein:" + nonce] = `${globalProductTitle}|${mainProduct.handle}|https:${mattress.featured_image}|${mainProductPrice.compare_at_price}|${mainProductPrice.price}|1,1,1,1,1`;
        //attributes["group:" + nonce] = "{{ product.title }}|{{ product.handle }}|{{ product.featured_image | img_url:'400x'}}|{{ product.compare_at_price }}|{{ product.price }}|1,1";

        Shopify.moveAlong = function() {
            // If we still have requests in the queue, let's process the next one.
            if (Shopify.queue.length) {
                const request = Shopify.queue.shift();
                //const data = 'id='+ request.variantId + '&quantity=1';
                args = { quantity: request.quantity, id: request.variantId, properties: request.properties }

                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: args,
                    success: function(res){
                        Shopify.moveAlong();
                    },
                    error: function(){
                        // if it's not last one Move Along else show cart drawer
                        if (Shopify.queue.length){
                            Shopify.moveAlong();
                        } else {
                            // show cart drawer
                            $('#product-buy').html('Add to cart').attr('disabled', false);
                            refreshCart(true);
                            // $(".header-cart").trigger("click");
                        }
                    }
                });
            } else {
                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: { attributes: attributes },
                    dataType: 'json',
                    success: function (data) {
                        // show cart drawer
                        $('#product-buy').html('Add to cart').attr('disabled', false);
                        refreshCart(true);
                        // $(".header-cart").trigger("click");
                    }
                });
            }
        };
        Shopify.moveAlong();
    });

    /** Calc .product-sheets-img-con position */
    function calcTop() {
        if ($(window).width() < 768) {
            $(".product-sheets-img-con").css("top", "auto")
        } else {
            let headerHeight = $("header").outerHeight()
            $(".product-sheets-img-con").css("top", headerHeight + 40)
        }
    }
    calcTop();
    $(window).on('resize', function() {
        calcTop();
    });
    /** End calc .product-sheets-img-con position */

    /* Faq section script */
    $(".faq-accordion-header").on("click", function() {
		if ($(this).hasClass("active")) {
			$(this).removeClass("active").next().slideUp()
		} else {
			$(".faq-accordion-header").removeClass("active")
			$(".faq-accordion-content").slideUp()
			$(this).addClass("active").next().slideDown()
		}
	});
    /* End faq section script */

    /* Product images script */
    $(`#${mainProduct.id}-images`).imagesLoaded(function () {
        $(`#${mainProduct.id}-images`).on("init", function () {
            let maxHeight = -1
            $(`#${mainProduct.id}-images .slick-slide img`).css("height", "auto").each(function () {
                maxHeight = maxHeight > $(this).outerHeight() ? maxHeight : $(this).outerHeight()
            })
            $(`#${mainProduct.id}-images .slick-slide video`).css("height", maxHeight)
        })

        $(`#${mainProduct.id}-images`).slick({
            arrows: false,
            fade: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        fade: false
                    }
                }
            ]
        });
    });

    $(`#${mainProduct.id}-thumbnails`).imagesLoaded(function () {
        if ($(window).width() >= 768) {
            $(`#${mainProduct.id}-thumbnails`).on('init', function (slick) {
                $(`.thumbnail${mainProduct.id}`).first().trigger('click');
            });

            $(`#${mainProduct.id}-thumbnails`).slick({
                arrows: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    });

    $(document).on("click",".product-images-thumbnail-each", function () {
        t = $(this);
        $('.product-images-thumbnail-each').removeClass("active");
        t.addClass("active");
        const mainImageId = t.data('id');
        let index = t.hasClass('slick-slide') ? t.data('slick-index') : t.parent('.slick-slide').data('slick-index');
        $(`#${mainImageId}`).slick("slickGoTo", index);
        // $(`#${mainProduct.id}-images`).slick("slickGoTo", t.index());
    });

    function updateMainImage(id) {
        let thumbnail_index = 0;
        $(".images-div").hide();
        ii = $("#"+id+"-images");
        tt = $("#"+id+"-thumbnails");
        dd = $("#"+id+"-images-div");
        if (ii.hasClass("slick-initialized")) {
            ii.slick("slickGoTo",thumbnail_index,false);
            tt.find('.slick-slide:nth-child('+(thumbnail_index+1)+')').find(".product-images-thumbnail-each").trigger("click");
            dd.show();
        } else {
            dd.show();
            ii.on("afterChange",function(slick,currentSlide) {
                thumbnail_index = ii.slick("slickCurrentSlide");
            });

            ii.slick({
                arrows:false,
                fade:true,
                rows:0,
                initialSlide: thumbnail_index,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots:true,
                            fade:false
                        }
                    }
                ]
            });

            //tt.show();
            if ($(window).width() >= 768) {
                tt.on('init', function(slick) {
                    tt.find('.slick-slide:nth-child('+(thumbnail_index+1)+')').find(".product-images-thumbnail-each").addClass('active');
                });

                tt.slick({
                    arrows: true,
                    slidesToShow: 5,
                    rows:0,
                    slidesToScroll: 1,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }
        }
    }

    function updateMobileImages(id) {
        let thumbnail_index = 0;
        $(".images-div-mobile").hide();
        ii = $("#"+id+"-images-mobile");
        dd = $("#"+id+"-images-div-mobile");

        if (ii.hasClass("slick-initialized")) {
            ii.slick("slickGoTo",thumbnail_index,false);
            dd.show();
        } else {
            dd.show();
            ii.on("afterChange",function(slick,currentSlide) {
                thumbnail_index = ii.slick("slickCurrentSlide");
            });

            ii.slick({
                arrows:false,
                fade:true,
                rows:0,
                initialSlide: thumbnail_index,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots:true,
                            fade:false
                        }
                    }
                ]
            });            
        }
    }
    /* End product images script */

    /* Mattress difference popup handle */
    $(".mattress-difference-popup-link").on("click",function(e){
        e.preventDefault();

        $.get('/pages/mattress?sections=mattress-features-compare', function (result, textStatus) {
            $('#mattress-difference-popup .ajax-content').html(result['mattress-features-compare']);
            $('#mattress-difference-popup').show();

            var delay_execute = setTimeout(() => {
                $.magnificPopup.open({
                    items: {
                    src: '#mattress-difference-popup',
                    type: 'inline'
                    },
                    callbacks:{
                    open:function(){
                        $("body").css("overflow","hidden");
                        changeImages();
  
                        $("#mattress-difference-popup .global-image").each(function(){
                            $(this).attr("src",$(this).attr("data-src"));
                            $(this).removeClass("lazy").addClass('loaded');
                        });

                        if ($(window).width() < 768) { 
                            if (!$("#mattress-difference-popup .mattress-features-compare-list").hasClass("slick-initialized")) {                                
                                $("#mattress-difference-popup .mattress-features-compare-list").slick({
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    centerMode: true,
                                    centerPadding: '0',
                                    arrows: true,
                                    dots: false,
                                    infinite: false,
                                    rtl: true,
                                    initialSlide: 1
                                })
                            }
                        }
                    },
                    close:function(){
                        $("body").css("overflow","auto");
                    }
                    }
                });
  
                clearTimeout(this);
            }, 100);
        });
    });

    /* mattress size popup handle */
    $('.mattress-size-popup-link').on('click', function(e){
        e.preventDefault();

        //-- load ajax content
        let product_url = "/products/mattress";

        if($('.product-variant-mattress .each-pro.active').length > 0) {
            product_url = "/products/" + $('.product-variant-mattress .each-pro.active').attr('data-handle');
        }

            $.get(product_url + '?view=mattress-size-guide', function (result, text_status) {                      
                $('#mattress-size-popup .ajax-content').html(result);
                $('#mattress-size-popup').show();
                      
                var delay_execute = setTimeout(() => {
                  $.magnificPopup.open({
                    items: {
                      src: '#mattress-size-popup',
                      type: 'inline'
                    },
                    callbacks:{
                      open:function(){
                        $("body").css("overflow","hidden");

                        $("#mattress-size-popup .lazy").each(function(){
                          $(this).attr("src",$(this).attr("data-src"));
                          $(this).removeClass("lazy");
                        });
                      },
                      close:function(){
                        $("body").css("overflow","auto");
                      }
                    }
                  });

                  clearTimeout(this);
                }, 100);
            });
    });

    /* Mattress selector handlers */
    $('.product-variant-mattress .each-pro').on('click', function(){
        const active_title = 'Mattress-'+$(this).attr('data-product-title');
        $('.product-variant-mattress .each-pro').removeClass('active');
        $(this).addClass('active');

        //-- set correct size selector
        $('.mattress-size').addClass('hide-mobile');
        $(`.mattress-size[data-handle="${$(this).attr('data-handle')}"]`).removeClass('hide-mobile');

        if($(this).attr('data-index') == '1') {
            mattress = mattress1;
        } else if($(this).attr('data-index') == '2') {
            mattress = mattress2;
        } else if($(this).attr('data-index') == '3') {
            mattress = mattress3;
        } else {
            mattress = mattress4;
        }

        //-- add mattress images
        for(var i=0;i<mainProduct.media.length;i++) {
            const curr_url = mainProduct.media[i].src;
            const curr_alt = mainProduct.media[i].alt;

            if($(`#${mainProduct.id}-images`).find(`img[alt="${curr_alt}"]`).length <= 0 && curr_alt != null) {
                $(`#${mainProduct.id}-thumbnails`).slick('slickAdd',`<li class="product-images-thumbnail-each thumbnail${mainProduct.id}" data-id="${mainProduct.id}-images"><img src="${curr_url}" class="image" alt='${curr_alt}'></li>`,0);
                $(`#${mainProduct.id}-images`).slick('slickAdd',`<li><img src="${curr_url}" class="image" alt='${curr_alt}'></li>`,0);
            }
        }

        //-- set the correct image
        // $(`#${mainProduct.id}-images`).find('img').each(function(){
        //     if($(this).attr('alt') != globalProductTitle && $(this).attr('alt') != active_title && $(this).attr('alt').includes('Mattress-')) {
        //         $(`#${mainProduct.id}-thumbnails`).slick('slickRemove',$(this).closest('.slick-slide').attr('data-slick-index'));
        //         $(`#${mainProduct.id}-images`).slick('slickRemove',$(this).closest('.slick-slide').attr('data-slick-index'));
        //     }
        // });
        //-- set the correct image
        let selectedImage = 0;
        $(`#${mainProduct.id}-thumbnails`).find('img').each(function(){
            const imageAlt = $(this).attr('alt');
            const slickImageIndex = $(this).closest('.slick-slide').attr('data-slick-index');
            console.log('imageAlt === active_title', imageAlt , active_title, imageAlt === active_title);
            if(imageAlt === active_title) {
                selectedImage = slickImageIndex;
            }
        });

        const delay = setTimeout(() => {
            $(`#${mainProduct.id}-thumbnails .slick-slide[data-slick-index="${selectedImage}"]`).trigger('click');
            setProduct();
            
            clearTimeout(this);
        }, 800);
    });
    $('.mattress-size select').on('change', function(){
        const val = $(this).val();
        $(this).parent().find('.text span').html(val);

        const delay = setTimeout(() => {
            setProduct();
            
            clearTimeout(this);
        }, 800);
    });

    /* global select handler */
    $(".global-select-div .option").on("click",function(e){
		e.preventDefault();
		e.stopPropagation();
        if(!$(this).hasClass("disabled")) {
            $(this).closest('.global-select-div').find(".option.active").removeClass('active');
            $(this).addClass('active');

            let elem = $(this).closest(".global-select-div");
            elem.removeClass("active");
            elem.find(".text").html($(this).html());
            elem.find("select").val($(this).attr("data-value")).trigger("change");
        }
	});
    $("body").on('click', function(e){
		let closestItem = $(e.target).closest(".option");
		let closestHeader = $(e.target).closest(".inner");
		let closestSelect = $(e.target).closest(".global-select-div");
		if(closestItem.length > 0) {
			return;
		}

		if(closestSelect.length == 0) {
			$(".global-select-div").removeClass("active");
		} else {
			closestSelect.addClass('active');
		}
	});
});

/** Sheets size guide popup */
$(function(){
    $(".product-sheet-size-guide-popup-link").on("click",function(e){
      e.preventDefault();

      //-- load ajax content
      const product_url = SHOP_URL + "/products/sheets";

      if($('#product-feature-popup-movein .ajax-content').html() == '') {   
          $.get(product_url + '?view=sheets-size-guide', function (result, text_status) {                      
              $('#product-feature-popup-movein .ajax-content').html(result);
              $('#product-feature-popup-movein').show();
                  
              var delay_execute = setTimeout(() => {
              $.magnificPopup.open({
                  items: {
                  src: '#product-feature-popup-movein',
                  type: 'inline'
                  },
                  callbacks:{
                  open:function(){
                      $("body").css("overflow","hidden");

                      $("#product-feature-popup-movein .lazy").each(function(){
                      $(this).attr("src",$(this).attr("data-src"));
                      $(this).removeClass("lazy");
                      });
                  },
                  close:function(){
                      $("body").css("overflow","auto");
                  }
                  }
              });

              clearTimeout(this);
              }, 100);
          });
      } else {
          $.magnificPopup.open({
              items: {
                  src: '#product-feature-popup-movein',
                  type: 'inline'
              },
              callbacks:{
                  open:function(){
                      $("body").css("overflow","hidden");

                      $("#product-feature-popup-movein .lazy").each(function(){
                          $(this).attr("src",$(this).attr("data-src"));
                          $(this).removeClass("lazy");
                      });
                  },
                  close:function(){
                      $("body").css("overflow","auto");
                  }
              }
          });
      }

    });
  });